import { useEffect } from 'react';
import './FeedbackToast.css';

export type FeedbackKind = 'error' | 'success';

type Props = {
  message: string;
  kind?: FeedbackKind;
  onClose: () => void;
};

const FeedbackToast = ({ message, kind = 'error', onClose }: Props) => {
  useEffect(() => {
    const timer = setTimeout(onClose, kind === 'success' ? 4000 : 5000);
    return () => clearTimeout(timer);
  }, [onClose, kind, message]);

  return (
    <div className="feedback-overlay" role="status" aria-live="polite">
      <div className={`feedback-popup feedback-${kind}`}>
        <div className="feedback-body">
          <span className="feedback-label">
            {kind === 'success' ? 'Готово' : 'Ошибка'}
          </span>
          <p className="feedback-text">{message}</p>
        </div>
        <button
          type="button"
          className="feedback-close"
          onClick={onClose}
          aria-label="Закрыть"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default FeedbackToast;
